import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Redirect, Link } from 'react-router-dom';
import slugify from 'slugify';

import { moves } from 'data/moves';
import { pokemon } from 'data/pokemon';
import poketypes from 'utils/poketypes';

import Wrap from 'components/Wrap';
import PokemonCard from 'components/PokemonCard';
import TypeBadge from 'components/TypeBadge';

class MoveSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pokemon: props.match.params.query.toLowerCase()
    }
  }

  componentWillReceiveProps() {
    this.setState({
      pokemon: this.props.match.params.query.toLowerCase()
    });
  }

  render() {

    const totalMoves = moves.length;

    const thisMove = moves.find((move) => {
      return slugify(move.name.toLowerCase()) === slugify(this.props.match.params.query.toLowerCase());
    });

    if(!thisMove) {
      return (
        <Redirect to="/moves/" />
      )
    } else {

      const prevMove = moves.find((move, index) => {
        return index === moves.indexOf(thisMove) - 1;
      }) || moves.find((move, index) => {
        return index === totalMoves - 1;
      });

      const nextMove = moves.find((move, index) => {
        return index === moves.indexOf(thisMove) + 1;
      }) || moves.find((move, index) => {
        return index === 0;
      });

      return (
        <div id="MoveSingle" className="MoveSingle">
          <Helmet>
            <link rel="canonical" href={"http://pokego.fyi/moves/"+thisMove.name.toLowerCase()} />
            <title>{thisMove.name} · Pokemon Go Move Stats · pokego.fyi</title>
            <meta name="description" content={thisMove.name+' is a '+thisMove.type+' type move with '+thisMove.power+' power, '+thisMove.cooldown+' cooldown, and '+thisMove.dps+' DPS in Pokemon Go.'+thisMove.pokemon.length+' Pokemon learn this move.'} />
          </Helmet>

          <Wrap>
            <div className="wrap:m nm-y:s nm-x:s s(m-x:a) bgc:white p:s">
              <nav className="d:f fld:r jc:sb ai:c  p-b:xs p-x:xs nm-x:s nm-t:xs m-y:s  bd-b:m bdc:light-pewter  ts:tiny lc:pewter">
                <div>
                  <Link className="d:b p:xs c:pewter fw:6  hv(o:75)" to="/moves/">← All Moves</Link>
                </div>
                <div className="d:f fld:r  ls:s">
                  <Link className="d:b p:xs bd-r:m bdc:light-pewter c:pewter  p-r:s  hv(o:75)" to={'/moves/'+slugify(prevMove.name.toLowerCase())}>
                    <span><span className="c:pewter">←</span> {prevMove.name}</span>
                  </Link>
                  <Link className="d:b p:xs c:pewter  p-l:s  hv(o:75)" to={'/moves/'+slugify(nextMove.name.toLowerCase())}>
                    <span>{nextMove.name} <span className="c:pewter">→</span></span>
                  </Link>
                </div>
              </nav>

              <article>
                <div className="g:12 wrap:xs m-x:a">
                  <header className="MoveSingle__Header  gcol:6  p-x:s">
                    <span className="MoveSingle__Kind  ts:tiny ls:s  c:pewter">{thisMove.kind} Move</span>
                    <h1 className="MoveSingle__Name  ts:accent fw:5 c:dark-pewter ws:nw">{thisMove.name}</h1>
                    <div className="MoveSingle__Type  m-t:xs  g:12">
                      <div className="gcol:6  p-r:xs" style={{maxWidth: '90px'}}>
                        <TypeBadge type={thisMove.type} />
                      </div>
                    </div>
                  </header>

                  <div className="MoveSingle__Dps  gcol:6  ta:r">
                    <div className="ts:tiny ls:s  c:pewter">DPS</div>
                    <div className="ts:accent fw:5 c:dark-pewter">{thisMove.dps.toFixed(2)}</div>
                    <div className="p-t:0 ts:tiny ls:s  c:pewter">+ STAB <span className="ts:body fw:5" style={{color: poketypes[thisMove.type].color}}>{thisMove.dpsSTAB}</span></div>
                  </div>
                </div>

                <section className="MoveSingle__Stats  wrap:xs m-t:xs  m-x:a">
                  <div className="d:t tl:f w:100  bd-y:m bdc:light-pewter  ts:body ta:c c:dark-pewter">
                    <div className="d:tc p:xs">
                      <div className="fw:5">{thisMove.cooldown}</div>
                      <div className="ts:tiny c:pewter">Cooldown</div>
                    </div>
                    <div className="d:tc p:xs">
                      <div className="fw:5">{thisMove.power}</div>
                      <div className="ts:tiny c:pewter">Power</div>
                    </div>
                    
                    {(thisMove.eps > 0) && (
                    <div className="d:tc p:xs">
                      <div className="fw:5">{thisMove.eps}</div>
                      <div className="ts:tiny c:pewter">EPS</div>
                    </div>
                    )}

                    {(thisMove.energyCost > 0) && (
                    <div className="d:tc p:xs">
                      <div className="fw:5">{Math.round(100 / thisMove.energyCost) + '%'}</div>
                      <div className="ts:tiny c:pewter">Energy Cost</div>
                    </div>
                    )}
                    
                 </div>
                </section>

                <section className="MoveSingle__Pokemon  wrap:xs m-y:m m-x:a">
                  <h1 className="ts:tiny ta:c c:pewter">Learned By {thisMove.pokemon.length} Pokemon</h1>
                  {thisMove.pokemon.map((number) => {
                    const thisPokemon = pokemon.find((pokemon) => {
                      return pokemon.number === number;
                    });

                    return (
                      <Link className="d:b hv(o:75)  bd-b:s bdc:light-pewter  bgc:white" to={'/pokemon/'+thisPokemon.name.toLowerCase()} key={thisPokemon.number}>
                        <PokemonCard pokemon={thisPokemon} />
                      </Link>
                    )
                  })}
                </section>
              </article>
            </div>
          </Wrap>
        </div>
      );
    }
  }
}

export default MoveSingle;



// WEBPACK FOOTER //
// ./src/scenes/MoveSingle.js